const remoteImageToastMsg = {
  /**
   *  원격 이미지 리스트 요청하기
   */
  GET_REMOTE_IMAGE_LIST_REQUEST_ERROR: '원격 이미지 리스트 요청하기 실패',

  /**
   *  원격 이미지 상세 정보 요청하기
   */
  GET_REMOTE_IMAGE_DETAIL_INFO_REQUEST_ERROR: '원격 이미지 상세 정보 요청하기 실패',

  /**
   *  원격 이미지 등록 요청하기
   */
  CREATE_REMOTE_IMAGE_REQUEST_ERROR: '원격 이미지 등록 요청하기 실패',
  CREATE_REMOTE_IMAGE_REQUEST_SUCCESS: '원격 이미지 등록 요청하기 성공',

  /**
   *  원격 이미지 수정 요청하기
   */
  EDIT_REMOTE_IMAGE_REQUEST_ERROR: '원격 이미지 수정 요청하기 실패',
  EDIT_REMOTE_IMAGE_REQUEST_SUCCESS: '원격 이미지 수정 요청하기 성공',
};

export default remoteImageToastMsg;
